import React from 'react';
import { Controller } from 'react-hook-form';
import { Grid, Typography } from '@material-ui/core';
import { addHours } from 'date-fns';

import DurationInput from 'components/DurationInput';
import { getDate } from 'helpers/getDate';
import { useDateSettingsFormat } from 'common/useDateSettingsFormat';
import { useTimeSettingsFormat } from 'common/useTimeSettingsFormat';
import { convertToArr } from 'helpers/_date-helpers';

const HoursSelectForm = ({
  classes,
  type,
  control,
  label,
  name,
  index,
  errors,
  setError,
  clearErrors,
  values,
  setValue,
}) => {
  const { dateFormat } = useDateSettingsFormat();
  const getTimeFormatHook = useTimeSettingsFormat();


  const changeEndDate = (hours) => {
    const [nextEndDate] = convertToArr(
      addHours(
        getDate(
          values.startDate[index],
          values.startHours[index],
          values.startMinutes[index],
          values.startAmPm?.[index],
          getTimeFormatHook
        ),
        hours,
      ),
      dateFormat,
      getTimeFormatHook
    );

    setValue(`endDate[${index}]`, nextEndDate);
  }

  const handleChange = ({ hours, minutes }) => {
    const duration = hours + minutes / 60;

    setValue(`hoursHours[${index}]`, hours);
    setValue(`hoursMinutes[${index}]`, minutes);
    changeEndDate(duration);

    clearErrors();
    if (duration === 0) {
      setError(`hoursHours[${index}]`, { type: 'partial-timeoff-duration', message: 'Timeoff should be longer than 0' });
    }
  };

  return (
    <Grid item xs={12} md={6} className={classes.zeroPaddingTop}>
      <label>
        <Typography variant="body1" color="textSecondary">
          PTO Time:
        </Typography>
        <Controller name={`hoursHours[${index}]`} control={control} />
        <Controller name={`hoursMinutes[${index}]`} control={control} />
        <DurationInput
          className={classes.timeField}
          title="PTO time"
          value={{ hours: values.hoursHours?.[index], minutes: values.hoursMinutes?.[index] }}
          onChange={handleChange}
          maxHours={7}
          minuteStep={15}
          error={Boolean(errors.hoursHours?.[index])}
        />
        {errors.hoursHours && errors.hoursHours[index] ? (
          <div className={classes.error}>{errors.hoursHours[index].message}</div>
        ) : null}
      </label>
    </Grid>
  );
};

export default HoursSelectForm;
